/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { FlexContainer, Button, theme } from "@nordcloud/gnui";

export const TableToolbar = styled(FlexContainer)`
  gap: ${theme.spacing.spacing04};
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: ${theme.breakpoints.md - 1}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const TableToolbarSearch = styled.div`
  flex: 100 1 auto;
  min-width: 0;

  @media (min-width: ${theme.breakpoints.md}px) {
    min-width: 12rem;
  }
`;

export const FilterButton = styled(Button).attrs({
  severity: "low" as const,
  icon: "filter" as const,
})`
  flex: 1 0 auto;
  justify-content: center;
`;

export const ToolbarButtonsWrapper = styled(FlexContainer).attrs({
  gap: theme.spacing.spacing04,
  alignItems: "center" as const,
})`
  flex: 1 0 auto;
`;
